import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';

export const CHANGE_TYPES = {
  SAME: 'same',
  GROW: 'grow',
  FALL: 'fall',
};

export const PREFIX = {
  [CHANGE_TYPES.SAME]: <></>,
  [CHANGE_TYPES.GROW]: <ArrowUpOutlined />,
  [CHANGE_TYPES.FALL]: <ArrowDownOutlined />,
};

export const COLOR = {
  [CHANGE_TYPES.SAME]: 'var(--primary)',
  [CHANGE_TYPES.GROW]: 'var(--success)',
  [CHANGE_TYPES.FALL]: 'var(--danger)',
};
